import { getCommonRoutes } from 'common/constants/routes/routes-common';
import { getAttributesRoutes } from 'common/constants/routes/routes-attributes';
import { getVideoAppRoutes } from 'common/constants/routes/routes-video';
import { useSmartLook } from 'common/hooks/use-smartlook';
import { ScopeCtx } from 'common/ui/inputs/scopes/scope-ctx';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { RetailerCtx } from 'common/ui/inputs/retailer/retailer-ctx';
import { LoadingContainer } from 'common/ui/containers/loading-container';
import { CQRSRevealResultContext } from 'common/ui/shared/cqrs-reveal-result';
import { useVideoAppContext } from 'common/ui/containers/video-app-context';
import { Redirects } from '../redirects';
import { Layout } from '../layout';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export function App() {
  const { active: isVideoApp } = useVideoAppContext();

  const commonRoutes = getCommonRoutes();
  const appRoutes = isVideoApp ? getVideoAppRoutes() : getAttributesRoutes();
  const routes = [...commonRoutes, ...appRoutes];

  const protectedRoutes = routes?.filter(route => route.checkAvailability() && !route.hiddenLayout && route.protected);
  const hiddenLayoutRoutes = routes?.filter(
    route => route.checkAvailability() && route.hiddenLayout && route.protected
  );
  const unprotectedRoutes = routes?.filter(route => route.checkAvailability() && !route.protected);

  useSmartLook(process.env.REACT_APP_SMARTLOOK_KEY || '');

  return (
    <RetailerCtx>
      <ScopeCtx>
        <CQRSRevealResultContext>
          <Redirects>
            <SentryRoutes>
              <Route element={<Layout />}>
                {protectedRoutes.map(route => (
                  <Route
                    path={route.path}
                    key={route.path}
                    element={
                      <Suspense fallback={<LoadingContainer type="fullwidth" />}>
                        <route.component />
                      </Suspense>
                    }
                  />
                ))}
              </Route>
              {[...unprotectedRoutes, ...hiddenLayoutRoutes].map(route => (
                <Route
                  path={route.path}
                  key={route.path}
                  element={
                    <Suspense fallback={<LoadingContainer type="fullwidth" />}>
                      <route.component />
                    </Suspense>
                  }
                />
              ))}
            </SentryRoutes>
          </Redirects>
        </CQRSRevealResultContext>
      </ScopeCtx>
    </RetailerCtx>
  );
}
